import {Component, HostBinding, Input, OnDestroy} from "@angular/core";
import {FUIOptionsService, SelectionsEvent} from "../../../framework/options.service";
import {Subscription} from "rxjs";
import {FUIAbstractOption} from "../../../framework/abstract-option";

@Component({
    selector: "fui-multiselect-option",
    styleUrls: ["./multiselect-option.component.scss"],
    templateUrl: "./multiselect-option.component.html"
})
export class FUIMultiselectOptionComponent extends FUIAbstractOption implements OnDestroy {
    @Input() allowLabelMarkup: boolean = false;
    @HostBinding("class.focussed") public focussed: boolean;
    private _$selections: Subscription;

    constructor(optionsService: FUIOptionsService) {
        super(optionsService);
    }

    /**
     *
     * @returns {boolean}
     */
    get valued(): boolean {
        return this._valued;
    }

    /**
     *
     * @param {boolean} valued
     */
    set valued(valued: boolean) {
        this.optionsService.select(this.option);
        this._valued = valued;
    }

    ngOnInit(): void {
        this._$selections = this.optionsService.selections$.subscribe((event: SelectionsEvent) =>
            this._valued = event.selections && event.selections.find((selection: any) => selection[this.field] === this.option[this.field])
        );
    }

    ngOnDestroy(): void {
        this._$selections.unsubscribe();
    }

    public click(): void {
    }

    /**
     * When focussed$ event is emitted by the checkbox control
     * @param focussed
     */
    public onFocussed(focussed: boolean): void {
        this.focussed = focussed;
    }
}
